<template>
  <div class="h-full">
    <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
      <!-- 表格头部搜索 -->
      <el-row class="flex">
        <selectStandardId @updateStandardId="updateStandardId" />
        <el-select
          size="small"
          v-model="selectMenuId"
          filterable
          clearable
          @change="selectMenuType"
          :placeholder="$t('pleaseSelectADirectoryType')"
          class="w-200px mr-10px ml-10px"
        >
          <el-option
            v-for="item in menuTypeList"
            :key="item.id"
            :label="`${$t(item.label)}`"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select
          data-cy="inputCode"
          class="w-200px mr-10px"
          v-if="selectMenuId === 1"
          size="small"
          v-model="params.TagId"
          clearable
          filterable
          :placeholder="$t('pleaseSelectTheObjectEncoding')"
          :loading="remoteLoading"
          :no-data-text="$t('nodataPressEnterToQuery')"
          remote
          @keyup.enter.native="
            (e) => {
              getTagCodeList(e)
            }
          "
        >
          <el-option
            v-for="item in tagCodeList"
            :key="item.id"
            :value="item.id"
            :label="`${item.code}[${item.name}]`"
          ></el-option>
        </el-select>
        <el-select
          v-if="selectMenuId === 2"
          size="small"
          class="w-200px mr-10px"
          v-model="params.DocumentId"
          clearable
          filterable
          :loading="loadDocumentList"
          :placeholder="$t('pleaseSelectADocumentName')"
          :no-data-text="$t('nodataPressEnterToQuery')"
          @keyup.enter.native="
            (e) => {
              getDocumentList(e)
            }
          "
        >
          <el-option
            v-for="item in documentList"
            :key="item.id"
            :label="`${item.code}[${item.name}]`"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-input
          @keyup.enter.native="initData('search')"
          v-model.trim="params.Identifier"
          clearable
          size="small"
          :placeholder="$t('identificationNamePrefixMatch')"
          class="w-200px mr-10px"
        ></el-input>
        <el-button @click="initData('search')" type="primary" data-cy="searchBtn">{{
          $t('search')
        }}</el-button>
        <el-button
          :disabled="!$hasAccess('create')"
          type="primary"
          @click="openAdd(null)"
          data-cy="openAdd"
          >{{ $t('create') }}</el-button
        >
        <el-button
          :disabled="!$hasAccess('delete')"
          @click="handleDelete(idArray)"
          type="danger"
          data-cy="delete"
          >{{ $t('delete') }}</el-button
        >
        <el-button :disabled="!$hasAccess('export')" @click="exportExcel" data-cy="exportPart">
          {{ $t('export') }}
        </el-button>
        <el-button @click="importFile" :disabled="!$hasAccess('import')">
          {{ $t('import') }}
        </el-button>
      </el-row>
      <!-- 表格开始 -->
      <div style="height: calc(100% - 104px)" class="mt-20px">
        <el-table
          :data="dataList"
          v-loading="listLoading"
          @selection-change="selectionChange"
          class="w-full"
          border
          :highlight-current-row="true"
          :row-key="(row) => row.relationId"
          @sort-change="sortChange"
          height="100%"
          stripe
          ref="multipleTable"
        >
          <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
          <el-table-column type="index" width="75" :label="$t('seqNo')"></el-table-column>
          <el-table-column
            prop="tagCode"
            :label="$t('tagCode')"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="tagName"
            show-overflow-tooltip
            sortable="custom"
            :label="$t('tagName')"
          ></el-table-column>
          <el-table-column
            prop="tagClassName"
            show-overflow-tooltip
            sortable="custom"
            :label="$t('tagClassName')"
          ></el-table-column>
          <el-table-column
            prop="documentCode"
            show-overflow-tooltip
            sortable="custom"
            :label="$t('documentCode')"
          ></el-table-column>
          <el-table-column
            prop="documentName"
            show-overflow-tooltip
            sortable="custom"
            :label="$t('documentName')"
          ></el-table-column>
          <el-table-column
            prop="revision"
            show-overflow-tooltip
            :label="$t('documentVersion')"
          ></el-table-column>
          <el-table-column
            prop="fileName"
            show-overflow-tooltip
            sortable="custom"
            :label="$t('fileName')"
          ></el-table-column>
          <el-table-column
            prop="identifier"
            show-overflow-tooltip
            sortable="custom"
            :label="$t('identifier')"
          ></el-table-column>
          <!-- <el-table-column
            prop="userName"
            show-overflow-tooltip
            sortable
            label="创建人"
          ></el-table-column> -->
          <el-table-column
            prop="createdTime"
            show-overflow-tooltip
            :label="$t('createdTime')"
          ></el-table-column>
          <el-table-column :label="$t('operate')" width="150">
            <template slot-scope="scope">
              <el-button
                :disabled="!$hasAccess('update')"
                size="mini"
                @click="openAdd(scope.row)"
                >{{ $t('edit') }}</el-button
              >
              <el-button
                :disabled="!$hasAccess('delete')"
                @click="handleDelete([scope.row.id])"
                size="mini"
                >{{ $t('delete') }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="mt-20px">
        <el-pagination
          @size-change="initData('sizeChange')"
          @current-change="initData"
          background
          :total="totalNumber"
          :current-page.sync="params.pageno"
          :page-size.sync="params.pagesize"
          :page-sizes="$pageSizeAll"
          layout="total, sizes, prev, pager, next, jumper"
          class="float-right"
        ></el-pagination>
      </div>
    </el-card>
    <!--新增/编辑关联关系弹框-->
    <el-dialog
      :title="_.isNil(currentEditTagId) ? $t('addANewAssociation') : $t('editTheAssociation')"
      :visible.sync="dialogVisible"
      @close="closeDialog('addForm')"
      :close-on-click-modal="false"
      data-cy="editDialog"
      v-dialogDrag
    >
      <!-- <el-tabs v-model="activeName">
        <el-tab-pane label name="first">
        </el-tab-pane>
      </el-tabs> -->
      <el-form :model="addForm" ref="addForm" :rules="rules">
        <el-form-item :label="$t('tagCode')" :label-width="formLabelWidth" prop="TagId">
          <el-select
            size="small"
            class="w-full"
            v-model="addForm.TagId"
            clearable
            filterable
            :disabled="!_.isNil(currentEditTagId)"
            :placeholder="$t('pleaseSelectTheObjectEncoding')"
            :loading="remoteLoading"
            :no-data-text="$t('nodataPressEnterToQuery')"
            @keyup.enter.native="
              (e) => {
                getTagCodeList(e)
              }
            "
          >
            <el-option
              v-for="item in tagCodeList"
              :key="item.id"
              :value="item.id"
              :label="`${item.code}[${item.name}]`"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('documentName')" :label-width="formLabelWidth" prop="documentId">
          <el-select
            size="small"
            class="w-full"
            v-model="addForm.documentId"
            clearable
            filterable
            :loading="loadDocumentList"
            :placeholder="$t('pleaseSelectADocumentName')"
            :disabled="!_.isNil(currentEditTagId)"
            @change="selectDocName"
            :no-data-text="$t('nodataPressEnterToQuery')"
            @keyup.enter.native="
              (e) => {
                getDocumentList(e)
              }
            "
          >
            <el-option
              v-for="item in documentList"
              :key="item.id"
              :label="`${item.code}[${item.name}]`"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('fileName')" :label-width="formLabelWidth" prop="FileId">
          <el-select
            size="small"
            class="w-full"
            v-model="addForm.FileId"
            clearable
            filterable
            :placeholder="$t('pleaseSelectAFileName')"
            :disabled="!_.isNil(currentEditTagId)"
            @click.native="checkDocId"
          >
            <el-option
              v-for="(item, index) in fileList"
              :key="index"
              :label="item.fileName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('identifier')" :label-width="formLabelWidth" prop="identifier">
          <el-input
            size="small"
            v-model="addForm.identifier"
            clearable
            :placeholder="$t('pleaseEnterADistinguishedName')"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer tc">
        <el-button type="primary" @click="handleAdd('addForm')" data-cy="savePartNumber">{{
          $t('save')
        }}</el-button>
        <el-button @click="dialogVisible = false">{{ $t('cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 下载进度 start -->
    <el-dialog
      width="300px"
      :visible.sync="downloadProgressVisible"
      :title="`${$t('downloadProgress')}`"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <el-progress :percentage="downloadProgress"></el-progress>
    </el-dialog>
    <!-- 下载进度 end -->
    <!-- 导入关联关系 -->
    <wiz-upload-file
      v-dialogDrag
      @refreshList="initData('search')"
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
    ></wiz-upload-file>
  </div>
</template>

<script type="text/ecmascript-6">
import ApiMixinTags from '@/assets/js/api/tags'
import ApiMixinCable from '@/assets/js/api/cableManagement'
import TagService from '@/services/tags'
// zh新增接口
import DocumentManagementService from '@/services/documentManagement'
import fnMixin from '@/assets/js/fnMixins'
import ApiMixinPartNumber from '@/assets/js/api/partNumber'
import selectStandardId from '../../components/selectStandardId'

export default {
  name: 'handoverRelation',
  components: {
    selectStandardId,
  },
  mixins: [ApiMixinTags, ApiMixinCable, ApiMixinPartNumber, fnMixin],
  data() {
    return {
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 1, // 目前状态页面1为下载模板 2为上传模板 3为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      uploadExcelDialog: false,
      downloadProgressVisible: false, // 加载框是否可见
      downloadProgress: 0,
      tagTypeList: [], // 类别下拉数据
      menuTypeList: [
        {
          id: 1,
          // label: '位号树',
          label: 'bitNumberTree',
        },
        {
          id: 2,
          // label: '文档树',
          label: 'documentTree',
        },
      ],
      dataList: [], // 数据列表
      listLoading: false, // 表格加载状态
      // 对象编码下拉集合
      tagCodeList: [],
      // 文档名称下拉集合
      documentList: [],
      // 文件名称下拉集合
      fileList: [],
      dialogVisible: false, // 新增窗口可见性
      uploadTableVisible: false, // 导入窗口可见性
      excelName: ['关联关系管理模板', '关联关系管理导入结果', '关联关系管理导出文件'],
      activeName: 'first',
      idArray: [], // 批量删除的数据id集合
      totalNumber: null,
      selectMenuId: 1,
      params: {
        // 查询数据的参数
        siteId: '',
        pageno: 1,
        pagesize: 15,
        Identifier: '',
        DocumentId: '',
        TagId: '',
      },
      addForm: {
        // 新增的表单参数
        TagId: '',
        FileId: '',
        documentId: '',
        identifier: '',
      },
      documentId: '', // 新增文档文档Id1
      formLabelWidth: '110px', // 表单区域标签宽度
      rules: {
        // TagId: [
        //   {
        //     required: true,
        //     // message: '对象编码不能为空',
        //     message: this.$t('objectEncodingCannotNull'),
        //   },
        // ],
        // FileId: [
        //   {
        //     required: true,
        //     message: this.$t('TheFileNameCannotbeEmpty'),
        //   },
        // ],
        // documentId: [
        //   {
        //     required: true,
        //     message: this.$t('documentNameCannotEmpty'),
        //   },
        // ],
      },
      totalSelection: [], // 存放跨页勾选的项
      currentEditTagId: null, // 当前更改的关联关系
      remoteLoading: false,
      loadDocumentList: false,
      sortName: 'tagCode', // 排序的字段
      sortType: 'asc', // 排序的方式 asc为升序, desc为降序
      //  标准部分
      standardId: localStorage.getItem('standardId'),
      currentRow: {}, // 当前行数据
    }
  },
  watch: {
    curDocId(val) {
      if (val) {
        this.getFileList(val)
      }
    },
    standardId(newVal) {
      if (newVal) {
        if (this.selectMenuId === 1) {
          this.getTagCodeList()
        } else {
          this.getDocumentList()
        }
        this.initData('search')
      }
    },
  },
  methods: {
    // 导入
    importFile() {
      this.uploadFileProps.visible = true
      this.uploadFileProps.active = 0
    },
    // 下载导入模板
    async exportTemplate() {
      const res = await DocumentManagementService.getTagFileAssociationTemplate()
      // 返回的是文件流
      if (res) {
        this.downLoadBlob({
          name: '关联关系导入模板.xlsx',
          data: res,
        })
      }
    },
    // 上传已填写的模板
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append(key, value)
      })
      const res = await DocumentManagementService.relationObjImport(formData)
      if (res) {
        this.uploadFileProps.active = 2
        this.downLoadBlob({
          name: '关联关系导入明细.xlsx',
          data: res,
        })
        this.initData('search')
      }
      this.uploadFileProps.btnLoading = false
    },
    updateStandardId(val) {
      this.standardId = val
    },
    // 排序
    async sortChange(column) {
      if (column.column === null) {
        return
      }
      // this.sortName = this.humpToUnderline(column.prop)
      this.sortName = column.prop
      if (column.order === 'ascending') {
        this.sortType = 'asc'
        this.initData()
      } else {
        this.sortType = 'desc'
        this.initData()
      }
    },
    // 类别下拉列表改变函数
    async selectTagType() {
      this.initData('search')
    },
    selectMenuType(val) {
      if (val === 1) {
        this.params.DocumentId = ''
      } else {
        this.params.TagId = ''
      }
    },
    // 获取类别下拉列表数据
    getTagTypeList(keywords) {
      this.apiTagsClass({
        method: 'tagClassByName',
        params: { keywords, parentId: ' ' },
        extra: { errorMsg: false },
      }).then((res) => {
        if (res && res.dataList && res.success) {
          this.tagTypeList = res.dataList
        }
      })
    },
    // 获取选中的条目id
    selectionChange(val) {
      // _.forEach(this.totalSelection, (item) => {
      // // 选中的列表中有存在项在当前表格中(val:注意每次返回的是当前页的选择项数组)
      //   if (_.find(this.dataList, ['relationId', item.relationId])) {
      //     this.totalSelection = _.difference(this.totalSelection, [item]) // 清空当前表格中已经选中的所有项
      //   }
      // })
      // this.totalSelection = [...this.totalSelection, ...val] // 先清空当前页的选择项在组合
      this.totalSelection = val
      // 获取id数组集合
      this.idArray = _.map(this.totalSelection, 'id')
    },
    // 获取对象编码下拉数据集合
    async getTagCodeList(e) {
      this.remoteLoading = true
      const params = {
        standardId: this.standardId,
        skipCount: 1,
        maxResultCount: 999,
        sorting: '',
        cateCode: 'Tag',
        filter: '',
        classIds: '',
      }
      if (e) {
        params.filter = e.target.value
      }
      const res = await TagService.getDynamicTableResult(params)
      this.remoteLoading = false
      if (res && res.data && res.code === 0) {
        this.tagCodeList = res.data
        this.filterTableName(this.tagCodeList)
      }
    },
    // 处理表名
    filterTableName(data) {
      _.map(data, (item) => {
        let tableName = ''
        Object.keys(item).forEach((key) => {
          if (key.includes('.code')) {
            item.code = item[key]
            tableName = key.split('.')[0]
          }
          if (key === `${tableName}.name`) {
            item.name = item[key]
          }
        })
        return item
      })
    },
    // 获取文档名称下拉数据集合
    async getDocumentList(e) {
      this.loadDocumentList = true
      const params = {
        standardId: this.standardId,
        skipCount: 1,
        maxResultCount: 999,
        sorting: '',
        cateCode: 'Document',
        filter: '',
        classIds: '',
      }
      if (e) {
        params.filter = e.target.value
      }
      const res = await TagService.getDynamicTableResult(params)
      this.loadDocumentList = false
      if (res && res.data && res.code === 0) {
        this.documentList = res.data
        this.filterTableName(this.documentList)
      } else {
        this.documentList = []
        this.$message.warning(res.message)
      }
    },
    // 获取文件名称下拉数据集合
    async getFileList(id) {
      const res = await DocumentManagementService.getFileList({
        id,
        standardId: this.standardId,
        isVersion: this.currentRow.isVersionTable,
        classId: this.currentRow.documentClassId,
      })
      if (res && res.length) {
        this.fileList = res
      } else {
        this.fileList = []
      }
    },
    async initData(type) {
      if (type === 'sizeChange') {
        // 关键字搜索和改变每页条数时
        this.params.pageno = 1
      }
      if (type === 'search') {
        this.params.pageno = 1
        this.totalSelection = []
      }
      this.listLoading = true
      const query = {
        SkipCount: (this.params.pageno - 1) * this.params.pagesize,
        MaxResultCount: this.params.pagesize,
        Sorting: `${this.sortName} ${this.sortType}`,
        Identifier: this.params.Identifier,
        TagId: this.params.TagId,
        DocumentId: this.params.DocumentId,
        StandardId: this.standardId,
      }
      const listRes = await DocumentManagementService.relationObjTable(query)
      if (listRes && listRes.data && listRes.code === 0) {
        this.dataList = listRes.data
        this.totalNumber = listRes.totalCount
        // 跨页面多选
        // _.forEach(this.dataList, (item) => {
        //   if (_.find(this.totalSelection, ['relationId', item.relationId])) {
        //     this.$nextTick(() => {
        //       this.$refs.multipleTable.toggleRowSelection(item, true)
        //     })
        //   }
        // })
      } else {
        this.$message.error(listRes.message)
      }
      this.listLoading = false
    },
    // 文档名称下拉选择操作
    selectDocName(val) {
      this.addForm.documentId = val
      this.addForm.FileId = ''
    },
    closeDialog() {
      // 关闭新增
      this.addForm = this.$options.data().addForm
      this.currentEditTagId = null
      this.documentId = ''
      // this.tagCodeList = []
      // this.documentList = []
    },
    openAdd(row) {
      if (row) {
        this.currentRow = row
        if (
          !_.find(this.tagCodeList, (el) => {
            return el.id === row.tagId
          })
        ) {
          this.tagCodeList.push({ id: row.tagId, code: row.tagCode, name: row.tagName })
        }
        if (
          !_.find(this.documentList, (el) => {
            return el.id === row.documentId
          })
        ) {
          this.documentList.push({
            id: row.documentId,
            code: row.documentCode,
            name: row.documentName,
          })
        }
        this.currentEditTagId = row.tagId
        this.addForm.TagId = row.tagId
        this.addForm.identifier = row.identifier
        this.addForm.documentId = row.documentId
        this.addForm.FileId = row.fileId
        this.addForm.id = row.id
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.addForm.clearValidate()
      })
    },
    handleAdd(formName) {
      // 点击新增保存按钮
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const params = {
            fileId: this.addForm.FileId,
            tagId: this.addForm.TagId,
            identifier: this.addForm.identifier,
            id: this.addForm.id,
          }
          if (!params.id) params.isManual = true
          const res = params.id
            ? await DocumentManagementService.relationObjEdit(params)
            : await DocumentManagementService.relationObjAdd(params)
          if (res && res.data && res.code === 0) {
            this.$message({
              type: 'success',
              message: params.id ? '编辑成功' : '新增成功',
              duration: 2000,
            })
            this.dialogVisible = false
            this.initData()
          } else {
            this.$message.error(res.message)
          }
        } else {
          this.$message({
            type: 'warning',
            message: this.$t('PleaseFollowthePromptstoFillintheCorrectForm'),
            duration: 2000,
          })
        }
      })
    },
    handleDelete(tagIdList) {
      // 删除数据
      if (tagIdList.length) {
        this.$confirm('是否确定要删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await DocumentManagementService.relationObjDelete(tagIdList)
            if (res && res.code === 0) {
              this.$message.success('删除成功')
              if (this.params.pageno > 1 && this.dataList.length === tagIdList.length) {
                this.pageno.pageno -= 1
              }
              this.initData()
              this.idArray = []
              this.$refs.multipleTable.clearSelection()
            }
          })
          .catch(() => {
            this.$message.warning('取消删除')
          })
      } else {
        this.$message.info('请选择要删除的数据')
      }
    },
    async exportExcel() {
      // 导出excel
      // 有勾选时
      if (this.idArray.length) {
        this.exportById()
        return
      }
      // 有关键字时
      if (this.params.keyword !== '') {
        this.exportByKeyword()
        return
      }
      this.$confirm(
        '当前没有选中任何记录,系统将默认导出系统中所有数据,该操作时间会比较长,请确认是否要继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(() => {
        this.exportByKeyword()
      })
    },
    // 如果没有勾选table，则根据过滤条件筛选
    async exportByKeyword() {
      // this.downloadProgressVisible = true
      const resParams = {
        skipCount: 0,
        maxResultCount: 999,
        sorting: '',
        identifier: this.params.Identifier,
        tagId: this.params.TagId,
        documentId: this.params.DocumentId,
        standardId: this.standardId,
      }
      const res = await DocumentManagementService.relationObjExport(resParams)
      if (res) {
        this.downLoadExcel('关联关系导出结果.xlsx', res)
      } else {
        this.downloadProgressVisible = false
        this.$message.error('导出失败')
      }
    },
    // 根据勾选id来导出excel
    async exportById() {
      // this.downloadProgressVisible = true
      const res = await DocumentManagementService.relationObjExport({
        ids: _.join(this.idArray, ','),
        standardId: this.standardId,
      })
      if (res) {
        this.downLoadExcel('关联关系导出结果.xlsx', res)
      } else {
        this.downloadProgressVisible = false
        this.$message.error('导出失败')
      }
    },
    async findDownloadProgress(fileId) {
      const res = await TagService.findDownloadProgress({
        id: fileId,
      })
      if (res && res.code === 0 && res.data) {
        if (res.data.length <= 3) {
          if (res.data === '-1') {
            this.$message.warning(res.msg)
            this.downloadProgressVisible = false
            return
          }
          this.downloadProgress = res.data
          setTimeout(() => {
            this.findDownloadProgress(fileId)
          }, 3000)
          return
        }
        this.downloadProgress = 100
        setTimeout(() => {
          this.downloadProgressVisible = false
          this.downloadProgress = 0
          window.location.href = `${currentEnv.VUE_APP_PLANT_SERVER}${res.data}`
        }, 300)
      }
    },
    changeDialog(data) {
      this.uploadExcelDialog = data
    },
    // 选择文件时检测文档是否选择提醒
    checkDocId() {
      if (this.addForm.documentId === '') {
        this.$message.warning('请先选择文档名称！')
      }
    },
  },
  computed: {
    curDocId() {
      return this.addForm.documentId
    },
    currentProject() {
      // 切换项目
      return this.$store.getters.currentProject || {}
    },
    currentTheme() {
      // 切换当前的主题
      return this.$store.getters['Theme/currentTheme'] || 'pr'
    },
  },
  async created() {
    this.rules = {
      TagId: [
        {
          required: true,
          // message: '对象编码不能为空',
          message: this.$t('objectEncodingCannotNull'),
        },
      ],
      FileId: [
        {
          required: true,
          message: this.$t('TheFileNameCannotbeEmpty'),
        },
      ],
      documentId: [
        {
          required: true,
          message: this.$t('documentNameCannotEmpty'),
        },
      ],
    }
    // 判断是否切换项目
    const oldTenantId = localStorage.getItem('oldTenantId')
    const newTenantId = localStorage.getItem('TenantId')
    this.standardId = localStorage.getItem('standardId')
    if (this.standardId && oldTenantId === newTenantId) {
      this.initData()
    }
    // this.params.siteId = this.currentProject.id
    // this.getTagTypeList(' ')
  },
  activated() {
    // this.standardId = localStorage.getItem('standardId')
  },
}
</script>

<style ref="stylesheet/scss" type="text/scss" lang="scss" scoped>

/deep/.el-table th > .cell {
  font-weight: bold;
}
.el-tabs__content {
  padding-left: 10px;
}

</style>
